import {View} from '@ab/components';
import template from '../templates/item';

class Item extends View {
    template = template;

    state = {
        active: false,
    };

    checkLastSymbolOfAmount = value => {
        const checkVal = value.split('');
        if (checkVal.includes('.')) {
            const res = value.split('.');
            if (res[res.length - 1].length === 1) {
                return value + '0';
            } else {
                return value;
            }
        } else {
            return value;
        }
    };

    checkHintAttributes = (model, key) => {
        if (model.hasOwnProperty('hint_attributes')) {
            const hasAttr = Object.keys(model.hint_attributes).includes(key);
            return hasAttr;
        } else {
            return false;
        }
    };

    toggle = () => {
        return this.setState({active: !this.state.active});
    };

    static displayName = 'Statements.Views.Item';
}

export default Item;
